import { Link } from "react-router-dom";
import { SITE } from "../data/site";
import styles from "./Footer.module.css";

const SERVICE_LINKS = [
  { to: "/services/lived-in-blondes", label: "Lived-in blondes" },
  { to: "/services/dimensional-color", label: "Dimensional color" },
  { to: "/services/brunettes", label: "Brunettes" },
  { to: "/services/coppers", label: "Coppers" },
  { to: "/services/hair-extensions", label: "Extensions" },
  { to: "/services/precision-cutting", label: "Precision cutting" },
];


const SITE_LINKS = [
  { to: "/#about", label: "About Cathryn" },
  { to: "/#work", label: "Transformations" },
  { to: "/#reviews", label: "Kind words" },
  { to: "/#visit", label: "Visit the studio" },
  { to: "/#book", label: "Book an appointment" },
  { to: "/#faq", label: "Before you book" },
];

function getReducedMotion(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function Footer() {
  const year = new Date().getFullYear();
  const scrollToTop = () => {
    const behavior = getReducedMotion() ? "auto" : "smooth";
    window.scrollTo({ top: 0, behavior });
  };

  return (
    <footer className={styles.footer}>
      <div className={`container-wide ${styles.cta}`}>
        <p className={styles.ctaLabel}>By appointment only</p>
        <h2 className={styles.ctaHeading}>
          One chair.
          <br />
          One booking, <em>in seconds.</em>
        </h2>
        <a
          id="footer-book-on-vagaro"
          href={SITE.bookingUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn--invert btn--lg"
          aria-describedby="footer-book-on-vagaro-hint"
        >
          Book on Vagaro
          <span aria-hidden="true">{"\u2197"}</span>
        </a>
        <span id="footer-book-on-vagaro-hint" className={styles.outboundHint}>
          Opens vagaro.com in a new tab.
        </span>
      </div>

      <div className={`container-wide ${styles.inner}`}>
        <div className={styles.brandRow}>
          <Link to="/" className={styles.wordmark} aria-label={`${SITE.name} home`}>
            {SITE.name}
          </Link>
          <p className={styles.tagline}>Quiet luxury editorial color, by appointment.</p>
          <button
            type="button"
            className={styles.toTop}
            onClick={scrollToTop}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path
                d="M3 10l5-5 5 5"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={styles.toTopLabel}>Back to top</span>
          </button>
        </div>

        <nav className={styles.linkGrid} aria-label="Footer">
          <div className={styles.linkCol}>
            <h3 className={styles.colHeading}>Services</h3>
            <ul className={styles.list}>
              {SERVICE_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className={styles.linkCol}>
            <h3 className={styles.colHeading}>Studio</h3>
            <ul className={styles.list}>
              {SITE_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
              <li>
                <a href={SITE.instagramHref} target="_blank" rel="noopener noreferrer">
                  Instagram
                </a>
              </li>
            </ul>
          </div>
          <div className={styles.linkCol}>
            <h3 className={styles.colHeading}>Contact</h3>
            <ul className={styles.list}>
              <li>
                <a href={`tel:${SITE.phoneHref}`}>{SITE.phone}</a>
              </li>
              <li>
                <a href={SITE.instagramHref} target="_blank" rel="noopener noreferrer">
                  {SITE.instagram}
                </a>
              </li>
              <li>{SITE.addressLine}</li>
              <li>{SITE.city}</li>
            </ul>
          </div>
        </nav>

        <div className={styles.copyRow}>
          <p className={styles.copy}>{SITE.addressLine}, {SITE.city}. &copy; {year} {SITE.name}.</p>
          <p className={styles.copyMeta}>Built by appointment only.</p>
        </div>
      </div>
    </footer>
  );
}
